import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState, useMemo, useEffect } from "react";
import AdminTable from "../Administrator/Helpers/AdminTable";
import { getPersonalPacket } from "src/store/Slices/ClientsSlice";
import SureModal from "src/components/Modals/SureModal";
import EditPacket from "./Modals/EditPacket";
import dayjs from "dayjs";
import { getClientsList } from "src/store/Slices/ClientsSlice";

const ClientPacket = ({
  clientInfo,
  title,
  page,
  pageSize,
  setPage,
  setPageSize,
  mnemo,
  packetInfo,
  setPacketInfo,
  payload,
}) => {
  const dispatch = useDispatch();

  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const [openDelitePacketModal, setOpenDelitePacketModal] = useState(false);

  const items = [
    {
      key: "1",
      label: "Редактировать",
      onClick: () => {
        setIsOpenEditModal(true);
      },
      disabled: !mnemo?.children?.find((el) => el.mnemo === "updateBtn"),
    },
    {
      key: "2",
      label: "Удалить",
      onClick: () => {
        setOpenDelitePacketModal(true);
      },
      disabled: !mnemo?.children?.find((el) => el.mnemo === "deleteBtn"),
    },
  ];

  // STORE
  const packetList = useSelector(
    (state) => state.ClientsSlice.getClientPersonalPacketList
  );
  const packetListLoading = useSelector(
    (state) => state.ClientsSlice.getClientPersonalPacketListLoading
  );
  console.log('packetList', packetList)
  
  const searchItemsMap = (keys, values) => {
    const formattedItems = {};
    if (keys && values) {
      keys.forEach((key, index) => {
        console.log(key, index);
        if (values[index] != undefined && values[index][0] != undefined) {
          if (key === "datePurchased") {
            formattedItems["datePurchased.From"] = dayjs(
              values[index][0]
            ).format("YYYY-MM-DD");
            formattedItems["datePurchased.To"] = dayjs(values[index][1]).format(
              "YYYY-MM-DD"
            );
          } else {
            formattedItems[key] = values[index][0];
          }
        }
      });
      return formattedItems;
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const payload = searchItemsMap(
      Object.keys(filters),
      Object.values(filters)
    );
    dispatch(
      getPersonalPacket({
        flag: "get",
        value: {
          UserId: clientInfo.id,
          count: pagination.pageSize,
          offset: pagination.pageSize * (pagination.current - 1),
          orderBy: sorter?.column?.dataIndex,
          isDesc: sorter.order
            ? sorter.order === "ascend"
              ? true
              : false
            : undefined,
          ...payload,
        },
      })
    );
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const onClickRowOne = (record) => {
    setPacketInfo(record);
  };

  const onClickYesDeletePacket = () => {
    console.log("packetik", packetInfo?.id);
    dispatch(
      getPersonalPacket({
        flag: "delete",
        value: {
          userPacketId: packetInfo?.id,
        },
      })
    ).then(() => {
      dispatch(
        getPersonalPacket({ flag: "get", value: { UserId: clientInfo?.id } })
      );
      dispatch(getClientsList());
      setOpenDelitePacketModal(false);
    });
  };

  const handleComplete = (packetInfo) => {
    dispatch(
      getPersonalPacket({
        flag: "post",
        value: {
          id: packetInfo?.id,
          isCompleted: !packetInfo?.isCompleted,
        },
      })
    ).then(() => {
      dispatch(
        getPersonalPacket({ flag: "get", value: { UserId: clientInfo?.id } })
      );
      dispatch(getClientsList(payload));
    });
  };

  const formatedPacketRows = useMemo(() => {
    return packetList?.data?.value?.rows?.map((element) => ({
      ...element,
      datePurchased: element.datePurchased
        ? dayjs(element?.datePurchased).format("DD.MM.YYYY")
        : "",
      isCompleted: element?.isCompleted != null && (
        <Switch
          onClick={() => {
            setPacketInfo(element);
            handleComplete(element);
          }}
          defaultChecked
          value={element?.isCompleted}
        />
      ),
    }));
  }, [packetList]);
  return (
    <>
      <SureModal
        visible={openDelitePacketModal}
        setVisible={setOpenDelitePacketModal}
        onClickYes={onClickYesDeletePacket}
      />
      <EditPacket
        packetModal={isOpenEditModal}
        setPacketModal={setIsOpenEditModal}
        clientInfo={clientInfo}
        packetInfo={packetInfo}
        payload={payload}
      />
      {window.innerWidth >= 768 && (
        <AdminTable
          scroll={{ x: 0, y: 200 }}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onChange={handleTableChange}
          loading={packetListLoading}
          onClickRowOne={onClickRowOne}
          columns={packetList}
          rows={formatedPacketRows}
          total={packetList?.data?.value?.totalCount}
          title={title}
          items={items}
        />
      )}
    </>
  );
};

export default ClientPacket;
